class AudioService {
  private audio: HTMLAudioElement | null = null;
  private currentUrl: string | null = null;
  private autoplayEnabled = true;

  private listeners: Record<string, ((...args: any[]) => void)[]> = {};

  on(event: 'play' | 'stop' | 'timeupdate', callback: (...args: any[]) => void) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
    return () => this.off(event, callback);
  }

  private off(event: 'play' | 'stop' | 'timeupdate', callback: (...args: any[]) => void) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  private emit(event: 'play' | 'stop' | 'timeupdate', ...args: any[]) {
    this.listeners[event]?.forEach((cb) => cb(...args));
  }

  setAutoplayEnabled(enabled: boolean) {
    this.autoplayEnabled = enabled;
  }

  canAutoplay() {
    return this.autoplayEnabled;
  }

  play(url: string) {
    if (!this.autoplayEnabled) return;

    if (this.audio && this.currentUrl !== url) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }

    if (!this.audio || this.currentUrl !== url) {
      this.audio = new Audio(url);
      this.currentUrl = url;
      this.attachTimeUpdateListener();
    }

    this.audio.play().then(() => {
      this.emit('play');
    });
  }

  stop() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.currentUrl = null;
      this.audio = null;
      this.emit('stop');
    }
  }

  pause() {
    if (this.audio) {
      this.audio.pause();
      this.emit('stop');
    }
  }

  private attachTimeUpdateListener() {
    if (!this.audio) return;

    this.audio.ontimeupdate = () => {
      this.emit('timeupdate', this.audio!.currentTime, this.audio!.duration);
    };
  }

  getCurrentAudio() {
    return this.audio;
  }
}

export const audioService = new AudioService();
